@file:OptIn(InternalResourceApi::class)

package com.appcreator.shared_compose.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.appcreator.shared_compose.generated.resources/"

@delegate:ResourceContentHash(-1_568_312_725)
internal val Res.font.material_outlined: FontResource by lazy {
      FontResource("font:material_outlined", setOf(
        ResourceItem(setOf(), "${MD}font/material_outlined.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("material_outlined", Res.font.material_outlined)
}
